import React, { FC, ReactNode } from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { formatUSD } from '@app/helpers/formatUSD';

interface Props {
  label: string;
  value: ReactNode;
}

export const LabeledValue: FC<Props> = ({ label, value }) => {
  return (
    <VStack alignItems="flex-start" gap={2}>
      <Text color="gray.15" fontSize={14}>
        {label}
      </Text>
      {typeof value === 'string' ? (
        <Text color="white" fontSize={16}>
          {value}
        </Text>
      ) : (
        value
      )}
    </VStack>
  );
};
